import {
	Box,
	AppBar,
	IconButton,
	Toolbar,
	Typography,
	useMediaQuery,
	Hidden,
	Container,
	Breadcrumbs,
	Link,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Menu, ArrowBack, WbSunny, Brightness2 } from '@material-ui/icons';
import React, { useState, useMemo, useEffect } from 'react';
import { useLocation, useHistory, Link as RouterLink } from 'react-router-dom';

import Drawer from '../components/Drawer';
import { useThemeSwitch } from '../context/ThemeContext';
import { useQuery } from '../hooks/useQuery';

import { useStyles } from './styles';

const displayNames = {
	usuarios: 'Usuários',
	accounts: 'Contas',
	stores: 'Lojas',
	carts: 'Carrinhos',
	indications: 'Indicações',
};

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const LinkRouter = props => <Link {...props} component={RouterLink} />;

type DashboardLayoutProps = {
	children?: React.ReactNode | React.ReactNode[];
};

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();
	const query = useQuery();
	const [drawerOpened, setDrawerOpened] = useState(false);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up('lg'));

	const { toggleTheme } = useThemeSwitch();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	const closeDrawer = () => {
		setDrawerOpened(false);
	};

	const pathnames = useMemo(() => {
		return (
			location.pathname
				.split('/')
				.filter(x => x)
				.slice(1)
				.map(pathname => ({
					// @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
					displayName: displayNames[pathname] ?? (query.get('name') || pathname),
					url: pathname,
				}))
		);
	}, [location, query]);

	return (
		<>
			<Drawer
				open={drawerOpened}
				close={closeDrawer}
				variant={matches ? 'permanent' : 'temporary'}
			/>
			<Box height="100vh" ml={matches ? '300px' : '0px'}>
				<AppBar color={theme.palette.type === 'light' ? 'primary' : 'default'} position="static">
					<Toolbar>
						{pathnames?.length < 2 && (
							<Hidden lgUp>
								<IconButton onClick={() => setDrawerOpened(true)} color="inherit" aria-label="Menu">
									<Menu />
								</IconButton>
							</Hidden>
						)}
						{pathnames?.length >= 2 && (
							<IconButton onClick={() => history.goBack()} color="inherit" aria-label="Back">
								<ArrowBack />
							</IconButton>
						)}

						<Typography noWrap variant="h6" color="inherit" className={classes.title}>
							{pathnames[pathnames.length - 1].displayName}
						</Typography>
						<IconButton color="inherit" onClick={toggleTheme}>
							{theme.palette.type === 'dark' ? <WbSunny /> : <Brightness2 />}
						</IconButton>
					</Toolbar>
				</AppBar>

				<Box
					component="main"
					display="flex"
					flexGrow={1}
					flexDirection="column"
					my="20px"
					height="100%"
				>
					<Container>
						<Breadcrumbs className={classes.root} separator=">" aria-label="breadcrumb">
							{pathnames.map((value, index) => {
								const last = index === pathnames.length - 1;
								const to = `/home/${pathnames
									.slice(0, index + 1)
									.map(pathname => pathname.url)
									.join('/')
									.toLowerCase()}`;

								return last ? (
									<Typography color="inherit" variant="subtitle2" key={to}>
										{value.displayName.toUpperCase()}
									</Typography>
								) : (
									<LinkRouter color="inherit" variant="subtitle2" to={to} key={to}>
										{value.displayName.toUpperCase()}
									</LinkRouter>
								);
							})}
						</Breadcrumbs>
						{children}
					</Container>
				</Box>
			</Box>
		</>
	);
};

export default DashboardLayout;
